var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"table-list"}},[_c('h2',[_vm._v("DynamoDB Tables")]),_vm._v(" "),_c('ul',_vm._l((_vm.tables),function(table){return _c('li',{key:table},[_c('router-link',{attrs:{"to":'/table/' + table}},[_vm._v(_vm._s(table))])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b13e56a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TableList.vue
// module id = null
// module chunks = 